import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function ProtectedPartnerRoute({ children }) {
  const { user, bootstrapped } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  if (!bootstrapped && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Verifying session...
      </div>
    );
  }
  if (!user) return <Navigate to="/partner/login" replace state={navState} />;
  if (user.role !== 'partner') return <Navigate to="/partner/login" replace />;
  return children;
}
